// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"856":"19746b40","952":"70e49d85"}[chunkId] + ".chunk.js";
};